export default __webpack_public_path__ + "static/media/v8.cfd44cfb.jpg";